<template>
  <b-modal
    ref="semContratante"
    title="Informe os dados abaixo para emissão e envio de boleto e NFs"
    size="xl"
    :dialog-class="'alteracao-tamanho-contratante'"
    :modal-class="'center-modal-contratante'"
    no-close-on-backdrop
    no-close-on-esc
    @hide="limparCampos"
  >
    <validation-observer ref="validacao">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-2">
          <b-form-group label="Tipo de inscrição">
            <b-select
              ref="tipoInscricao"
              v-model="dadosContratante.tipoInscricaoEmpresa"
              :options="['CNPJ','CPF']"
              @change="limparDeterminadosCampos"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <b-form-group label="Informe a inscrição">
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="'Inscrição'"
            >
              <b-input-group>
                <masked-input
                  ref="cadastroFederal"
                  v-model="dadosContratante.inscricao"
                  :mask="mascaraCadFederal"
                  class="form-control"
                />
                <b-input-group-append>
                  <b-button
                    v-b-tooltip.hover
                    title="Busca dados"
                    variant="primary"
                    @click="buscarDados(dadosContratante)"
                  >
                    <feather-icon
                      v-if="dadosContratante.buscado"
                      icon="CheckIcon"
                    />
                    <feather-icon
                      v-else
                      icon="SearchIcon"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <small
                v-if="dadosContratante.erroNavegacao"
                class="text-danger"
              >Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!</small>
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <div class="col-12 col-lg-7">
          <b-form-group :label="dadosContratante.tipoInscricaoEmpresa === 'CPF' ? 'Nome' : 'Razão Social'">
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="dadosContratante.tipoInscricaoEmpresa === 'CPF' ? 'Nome' : 'Razão Social'"
            >
              <b-input v-model="dadosContratante.nomeRazaoSocial" />
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </div>
      </div>

      <div>
        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CNPJ'"
          class="row mt-50"
        >
          <div class="col">
            <b-form-group label="Nome Fantasia">
              <b-input
                v-model="dadosContratante.nomeFantasia"
              />
            </b-form-group>
          </div>
        </div>

        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CNPJ'"
          class="row mt-50"
        >
          <div
            class="col-12 col-md-12 col-lg-5"
          >
            <legend class="col-form-label  pt-0">
              Optante pelo Simples Nacional
            </legend>
            <validation-provider
              #default="{ errors }"
              :rules="'required'"
              :name="'Simples Nacional'"
            >
              <b-select
                v-model="dadosContratante.simplesNacional"
                name="filtroDataPesquisa"
                class="search-items"
              >
                <option
                  v-for="(cert, index) in simplesNacional"
                  :key="index"
                  :value="cert.value"
                >{{ cert.text }}
                </option>
              </b-select>
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </div>
          <div class="col-12 col-md-12 col-lg-7">
            <telefone-celular
              :value="dadosContratante.telefoneContato"
            />
          </div>
        </div>
      </div>
      <div class="row mt-50">
        <div class="col">
          <email-input
            :value="dadosContratante.emailsBoletosNFs"
            :require="true"
            @input="adicionarEmail($event)"
          />
        </div>
        <div
          v-if="dadosContratante.tipoInscricaoEmpresa === 'CPF'"
          class="col-12 col-md-12 col-lg-5"
        >
          <telefone-celular
            :value="dadosContratante.telefoneContato"
          />
        </div>
      </div>

      <div :class="'row mt-50'">
        <div class="col-12 col-md-6 col-lg-3">
          <cep-input
            :value="dadosContratante.cep"
            :externo="true"
            @atualizar-endereco="enderecoBuscado"
          />
        </div>
        <b-form-group
          label="Endereço"
          class="col-12 col-md-6 col-lg-6"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'endereço'"
          >
            <b-form-input
              v-model="dadosContratante.logradouro"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Número"
          class="col-12 col-md-6 col-lg-3"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Número'"
          >
            <b-form-input
              v-model="dadosContratante.numero"
              @keypress="isNumber($event)"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
      </div>

      <div class="row mt-50">
        <b-form-group
          label="Complemento"
          class="col-12 col-md-6 col-lg-3"
        >
          <b-form-input
            v-model="dadosContratante.complemento"
          />
        </b-form-group>
        <b-form-group
          label="Bairro"
          class="col-12 col-md-6 col-lg-4"
        >
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Bairro'"
          >
            <b-form-input
              v-model="dadosContratante.bairro"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <div class="col-12 col-md-6 col-lg-3">
          <legend class="col-form-label pt-0">
            Cidade
          </legend>
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Cidade'"
          >
            <municipio-select
              v-model="dadosContratante.cidade"
              :externo="true"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <legend class="col-form-label pt-0">
            Estado
          </legend>
          <validation-provider
            #default="{ errors }"
            :rules="'required'"
            :name="'Estado'"
          >
            <estado-select
              v-model="dadosContratante.uf"
              :externo="true"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <template #modal-footer>
      <div
        class="row container-button-contratante"
      >
        <div class="col-12 col-md-12 col-lg-8">
          <b-btn
            style="width: 100%;"
            variant="primary"
            @click="aprovarProposta"
          >
            Confirmar aprovação da proposta
          </b-btn>
        </div>
        <div class="col-12 col-md-12 col-lg-4">
          <b-btn
            style="width: 100%;"
            variant="danger"
            class="btn-cancelar-contratante"
            @click="$refs.semContratante.hide()"
          >
            Cancelar
          </b-btn>
        </div>
      </div>
    </template>
    <loading
      :is-loading="isLoading"
      :show-cancel-button="false"
      :show-message="'Aguarde estamos buscando os dados no sistema!'"
    />
  </b-modal>
</template>

<style lang="scss">

.container-button-contratante{
  width: 34rem;
}
.alteracao-tamanho-contratante {
  width: 1100px !important;

}

.center-modal-contratante {
  display: flex !important;
  justify-content: center !important;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .alteracao-tamanho-contratante {
    max-width: 90%;
    height: 100vh;

  }

}
@media screen and (max-width: 991px) {
  .btn-cancelar-contratante{
    margin-top: 1rem;
  }
  .container-button-contratante{
    width: 100%;
  }
}
</style>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'

export default {
  name: 'DadosContratanteExterno',
  components: {
    ValidationProvider,
    ValidationObserver,
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
    CepInput: () => import('@/@pilar/components/cep-input/CepInput.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
  },
  data() {
    return {
      dadosContratante: {
        tipoInscricaoEmpresa: 'CPF',
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        simplesNacional: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        buscado: false,
      },
      isLoading: false,
      invalidTags: [],
      duplicateTags: [],
      simplesNacional: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
    }
  },
  methods: {
    adicionarEmail(value) {
      this.dadosContratante.emailsBoletosNFs = value
    },
    show() {
      this.dadosContratante.emailsBoletosNFs.push(getUserInfo().email)
      this.$refs.semContratante.show()
    },
    mascaraCadFederal() {
      if (this.dadosContratante.tipoInscricaoEmpresa === 'CPF') {
        return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.dadosContratante.emailsBoletosNFs = emails
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    aprovarProposta() {
      this.$refs.validacao.validate()
        .then(result => {
          if (result) {
            this.$emit('aprovado', this.dadosContratante)
            this.$refs.semContratante.hide()
          } else {
            this.$erro('Preencha os campos obrigatórios!')
          }
        })
    },
    limparCampos() {
      this.dadosContratante = {
        tipoInscricaoEmpresa: 'CPF',
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
      }
    },
    enderecoBuscado(value) {
      this.$set(this.dadosContratante, 'logradouro', value.logradouro)
      this.$set(this.dadosContratante, 'bairro', value.bairro)
      this.$set(this.dadosContratante, 'complemento', value.complemento)
      this.$set(this.dadosContratante, 'uf', value.uf)
      this.$set(this.dadosContratante, 'cidade', value.cidade)
      this.$set(this.dadosContratante, 'cep', value.cep)
    },
    // eslint-disable-next-line consistent-return
    isNumber(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[0-9]+$/.test(char)) return true
      e.preventDefault()
    },
    buscarDados(dados) {
      this.dadosContratante.erroNavegacao = false
      this.isLoading = true
      api.buscaPropostaContratante(dados)
        .then(payload => {
          if (payload.data) {
            const { data } = payload
            this.dadosContratante = data
            if (!this.dadosContratante.emailsBoletosNFs || (this.dadosContratante.emailsBoletosNFs && this.dadosContratante.emailsBoletosNFs.length === 0)) {
              this.dadosContratante.emailsBoletosNFs = []
              this.dadosContratante.emailsBoletosNFs.push(getUserInfo().email)
            }
          } else if (dados.tipoInscricaoEmpresa === 'CPF') {
            this.$erro('CPF não encontrado em nossa base de dados, preencha os campos manualmente.')
          }

          this.dadosContratante.buscado = true
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    limparDeterminadosCampos(value) {
      this.dadosContratante = {
        nomeRazaoSocial: null,
        nomeFantasia: null,
        inscricao: null,
        emailsBoletosNFs: [],
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
      }
      this.$set(this.dadosContratante, 'tipoInscricaoEmpresa', value)
    },
  },
}
</script>
